<div class="visits-wrapper">
  @for (formGroup of previousVisitsArray; track formGroup; let formGroupIndex = $index) {
    <div class="visit-group-container" [formGroup]="formGroup">
      <div class="left-column">
        <div class="visit-row">
          @if (formGroup.controls.entryDate; as entryDate) {
            <div class="standard-form-field required-field">
              <label
                [for]="'polandVisit' + formGroupIndex + 'entryDate'"
                [class.invalid]="entryDate.touched && entryDate.invalid">
                {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-ENTRY-DATE.MAIN-LABEL' | translate }}
                <span aria-hidden="true">&nbsp;*</span>
                <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
              </label>
              <mat-form-field appearance="outline">
                <input
                  id="polandVisit{{ formGroupIndex }}entryDate"
                  matInput
                  type="text"
                  inputmode="numeric"
                  mask="00.00.0000"
                  [keepCharacterPositions]="true"
                  [clearIfNotMatch]="true"
                  [showMaskTyped]="true"
                  [dropSpecialCharacters]="false"
                  [required]="true"
                  [attr.aria-required]="true"
                  [attr.aria-invalid]="entryDate.touched && entryDate.invalid ? 'true' : null"
                  [attr.aria-describedby]="
                    entryDate.touched && entryDate.invalid
                      ? 'entryDateTooltip' + formGroupIndex + ' entryDateError' + formGroupIndex
                      : 'entryDateTooltip' + formGroupIndex
                  "
                  placeholder="DD.MM.YYYY"
                  formControlName="entryDate"
                  autocomplete="off" />
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'entryDateTooltip' + formGroupIndex"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.POLAND-VISIT-ENTRY-DATE.FORMAT-HINT' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (entryDate.touched && entryDate.invalid) {
                  <mat-error [id]="'entryDateError' + formGroupIndex">
                    {{ entryDate.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (formGroup.controls.leaveDate; as leaveDate) {
            <div class="standard-form-field required-field">
              <label
                [for]="'polandVisit{{ formGroupIndex }}leaveDate'"
                [class.invalid]="leaveDate.touched && leaveDate.invalid">
                {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.MAIN-LABEL' | translate }}
                <span aria-hidden="true">&nbsp;*</span>
                <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
              </label>
              <mat-form-field appearance="outline">
                @if (leaveDate.value !== 'OBECNIE') {
                  <input
                    id="polandVisit{{ formGroupIndex }}leaveDate"
                    matInput
                    type="text"
                    inputmode="numeric"
                    mask="00.00.0000"
                    [keepCharacterPositions]="true"
                    [clearIfNotMatch]="true"
                    [showMaskTyped]="true"
                    [dropSpecialCharacters]="false"
                    [required]="true"
                    [attr.aria-required]="true"
                    [attr.aria-invalid]="leaveDate.touched && leaveDate.invalid ? 'true' : null"
                    [attr.aria-describedby]="
                      leaveDate.touched && leaveDate.invalid
                        ? 'leaveDateTooltip' + formGroupIndex + ' leaveDateError' + formGroupIndex
                        : 'leaveDateTooltip' + formGroupIndex
                    "
                    formControlName="leaveDate"
                    placeholder="DD.MM.YYYY"
                    autocomplete="off" />
                }
                @if (leaveDate.value === 'OBECNIE') {
                  <input matInput [required]="false" [disabled]="true" autocomplete="off" />
                }
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'leaveDateTooltip' + formGroupIndex"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.FORMAT-HINT' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (leaveDate.touched && leaveDate.invalid) {
                  <mat-error [id]="'leaveDateError' + formGroupIndex">
                    {{ leaveDate.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
        <div class="visit-row">
          @if (formGroup.controls.legalBasis; as legalBasis) {
            <div class="standard-form-field widened-field legalBasis-field">
              <label [id]="'legalBasisLabel' + formGroupIndex">{{
                'PERSONAL_DATA_FORM.LEGAL_BASIS' | translate
              }}</label>
              <mat-form-field appearance="outline">
                <mat-select
                  id="polandVisit{{ formGroupIndex }}legalBasis"
                  [panelClass]="['standard-select', 'legal-basis-select']"
                  placeholder="{{ 'COMMON.PLACEHOLDER.SELECT_BASIS' | translate }}"
                  formControlName="legalBasis"
                  [attr.aria-required]="true"
                  [attr.aria-labelledby]="'legalBasisLabel' + formGroupIndex"
                  [attr.aria-invalid]="legalBasis.touched && legalBasis.invalid ? 'true' : null"
                  [attr.aria-describedby]="
                    legalBasis.touched && legalBasis.invalid ? 'legalBasisError' + formGroupIndex : null
                  ">
                  @for (item of legalBasisOfStayList.tempPremit; track item) {
                    <mat-option [value]="item.value">
                      {{ 'SELECTS_VALUES.STAY_LEGAL_BASIS_NEW.' + item.labelKey | translate }}
                    </mat-option>
                  }
                </mat-select>
                <!-- ERROR -->
                @if (legalBasis.touched && legalBasis.invalid) {
                  <mat-error [id]="'legalBasisError' + formGroupIndex">
                    {{ legalBasis.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
        @if (getControl('legalBasis', formGroupIndex).value === LEGAL_BASIS_OF_STAY.OTHER) {
          <div class="visit-row">
            <div class="standard-form-field widened-field legalBasisComment-field required-field">
              <label>
                {{ 'PERSONAL_DATA_FORM.EXPLAIN_OTHER_BASIS' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  maxLength="2000"
                  minLength="1"
                  placeholder="{{ 'PERSONAL_DATA_FORM.ENTER_EXPLANATION' | translate }}"
                  formControlName="legalBasisComment" />
              </mat-form-field>
            </div>
          </div>
        }
      </div>
      <div class="right-column">
        @if (previousVisitsArray.length > 1) {
          <div class="visit-actions">
            @if (currentlyLivingInPolandFc.value !== false) {
              <div class="currently-checkbox-wrapper">
                <label [id]="'currentlyCheckboxLabel' + formGroupIndex" class="checkbox-label">
                  {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY' | translate }}
                </label>
                <mat-checkbox
                  class="currently-checkbox"
                  id="currentlyCheckbox{{ formGroupIndex }}"
                  aria-labelledby="currentlyCheckboxLabel{{ formGroupIndex }}"
                  matTooltip="{{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY-HINT' | translate }}"
                  matTooltipClass="personalDataFormTooltip"
                  [matTooltipDisabled]="currentlyIndex === formGroupIndex"
                  [checked]="formGroup.get('leaveDate').value === 'OBECNIE'"
                  [disabled]="formGroup.disabled"
                  (change)="currentlyChanged($event, formGroupIndex)">
                </mat-checkbox>
              </div>
            }
            @if (formGroup.get('leaveDate').value !== 'OBECNIE') {
              <button
                id="removeVisit{{ formGroupIndex }}Button"
                mat-icon-button
                [disabled]="showLoading || disabled"
                (click)="removeVisit(formGroupIndex)"
                [attr.aria-label]="'COMMON.LABEL.DELETE_ELEMENT' | translate">
                <mat-icon [class]="showLoading ? 'trash-disabled' : 'trash'" svgIcon="trash"></mat-icon>
              </button>
            }
          </div>
        }
        @if (previousVisitsArray.length === 1) {
          <div class="visit-actions">
            @if (currentlyLivingInPolandFc.value !== false) {
              <div class="currently-checkbox-wrapper">
                <label [id]="'currentlyCheckboxLabel' + formGroupIndex" class="checkbox-label">
                  {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY' | translate }}
                </label>
                <mat-checkbox
                  class="currently-checkbox"
                  id="currentlyCheckbox{{ formGroupIndex }}"
                  aria-labelledby="currentlyCheckboxLabel{{ formGroupIndex }}"
                  matTooltip="{{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY-HINT' | translate }}"
                  matTooltipClass="personalDataFormTooltip"
                  [matTooltipDisabled]="currentlyIndex === formGroupIndex"
                  [checked]="formGroup.get('leaveDate').value === 'OBECNIE'"
                  [disabled]="formGroup.disabled"
                  (change)="currentlyChanged($event, formGroupIndex)">
                </mat-checkbox>
              </div>
            }
            <button
              mat-icon-button
              [disabled]="true"
              [attr.aria-label]="'COMMON.LABEL.DELETE_ELEMENT_UNAVAILABLE' | translate">
              <mat-icon
                #trash_disabled="matTooltip"
                (click)="$event.preventDefault(); trash_disabled.toggle()"
                class="trash-disabled"
                svgIcon="trash"
                matTooltip="{{ 'PERSONAL_DATA_FORM.POLAND-VISIT-DELETE-DISABLED-HINT' | translate }}"
                matTooltipClass="personalDataFormTooltip">
              </mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  }

  <div class="all-groups-actions">
    <button
      [disabled]="showLoading || disabled || allVisitsCorrect() === false"
      id="addNewVisitInPolandButton"
      (click)="addNewVisit()"
      class="standard-form-button add-visit-button">
      {{ 'STAYS_IN_POLAND.ADD_STAY' | translate }}
    </button>

    @if (showLoading) {
      <div class="loading-wrapper" role="status" aria-live="polite">
        <span class="sr-only">
          {{ 'COMMON.LAYOUT.LOADING' | translate }}
        </span>
        <mat-spinner
          id="personalDetailsPreviousVisitsSavingLoading"
          [diameter]="35"
          [attr.aria-hidden]="true"></mat-spinner>
      </div>
    }
    @if (showSaved) {
      <div class="notification-wrapper saved-notification" aria-live="polite">
        <mat-icon svgIcon="check-outline"></mat-icon>
        <span id="personalDetailsPreviousVisitsSavingDone" class="text"
          >{{ 'STAYS_IN_POLAND.SAVED_SUCCESSFULLY' | translate }}
        </span>
      </div>
    }
    @if (!showSaved && !showLoading) {
      <div class="notification-wrapper awaiting-notification" aria-live="polite">
        <span id="personalDetailsPreviousVisitsWaiting" class="text"
          >{{ 'STAYS_IN_POLAND.AWAITING_FOR_ALL_REQUIRED_DATA' | translate }}
        </span>
      </div>
    }
  </div>
</div>
